import type { FaireThemeEntity } from "../../entity_types/theme";

export const swedish_dishcloths_eco_home_care: FaireThemeEntity = {
  token: "swedish-dishcloths-eco-home-care",
  type: "theme",
  name: "Swedish Dishcloths & Eco Home Care",
  description: "",
  teaser: "",
  detail: "",
  bgColor: "#EDE0F5",
  exactProducts: true,
  retailerToken: "r_eer7xgiweo",
  productTokens: [
    "p_mfh9nxeyyd",
    "p_5xc55zh7td",
    "p_tt673pkfsc",
    "p_phzknxfsc4",
    "p_984qk5y7vh",
    "p_7pfyxf4v34",
    "p_uyy8yrgvax",
    "p_cca44grfy4",
    "p_wes5cp9fth",
    "p_6fo5jd08gd",
    "p_tffn37ns9k",
    "p_7q8vhxwznk",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
